import axios from 'axios'
import { push } from 'connected-react-router'

// Add a response interceptor
export const setupAxiosHandler = (store) => {    
    axios.interceptors.response.use(function (response) {                
        return response;
    }, function (error) {                
        if (error.response.status === 403) {            
            store.dispatch(push('/403'));
        }
        if (error.response.status === 405 && error.response.data.detail=== "Method \"Not Allowed for DEMO ACCOUNT\" not allowed.") {            
            error.response.status = 200;
            return error.response;
        }
        return Promise.reject(error);
    });

    axios.interceptors.request.use(function (config) {        
        if (config.url[config.url.length - 1] !== '/'){
            config.url += '/';
        }
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });    
}